// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--10-1!../../node_modules/sass-loader/lib/loader.js??ref--10-2!./lib.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("67797986", content, true);


//////////////////
// WEBPACK FOOTER
// ./src/styles/lib.scss
// module id = 3
// module chunks = 0